var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('MonthPickerInput',{attrs:{"default-month":_vm.currentMonth,"default-year":_vm.currentYear,"input-pre-filled":"","lang":"pt"},on:{"input":_vm.onDateSelection}})}
var staticRenderFns = []

export { render, staticRenderFns }